import { FC, useState } from "react"
import { useUser } from "../../stores/user"
import { UserSectionProps } from "../../pages/User"
import Button from "../Button"
import Col from "../Col"
import Card from "../Card"
import Row from "../Row"
import { formatDate, formatDateHour } from "../../helpers/date"
import { userStatusMap } from "../../constants/user"
import Modal from "../Modal"
import EditUserDataForm from "../EditUserDataForm"
import { User } from "../../sdk"
import { toast } from "react-toastify"

const UserGeneral: FC<UserSectionProps> = ({ user }) => {
  const setUser = useUser(state => state.setUser)

  const [editUserDataModalOpen, setEditUserDataModalOpen] = useState<boolean>(false)

  return (
    <>
      <div className="grid grid-cols-12 gap-x-10 mt-8">
        <Col lg={6}>
          <Card heading="Generali">
            <ul>
              <Row as="li" className="card__row" justify="between">
                <div className="card__row-title">Nome</div>
                {user.firstname}
              </Row>

              <Row as="li" className="card__row" justify="between">
                <div className="card__row-title">Cognome</div>
                {user.lastname}
              </Row>

              <Row as="li" className="card__row" justify="between">
                <div className="card__row-title">Email</div>
                {user.email}
              </Row>

              {user.birthDate &&
                <Row as="li" className="card__row" justify="between">
                  <div className="card__row-title">Data di nascita</div>
                  {formatDate(user.birthDate)}
                </Row>
              }

              <Row as="li" className="card__row" justify="between">
                <div className="card__row-title">Stato</div>
                {userStatusMap[user.status]}
              </Row>

              {user.organizationName &&
                <Row as="li" className="card__row" justify="between">
                  <div className="card__row-title">Nome organizzazione</div>
                  {user.organizationName}
                </Row>
              }
            </ul>
            <Button
              className="mt-8"
              onClick={(): void => {
                setEditUserDataModalOpen(true)
              }}
            >
              Modifica dati utente
            </Button>
          </Card>
        </Col>

        <Col lg={6}>
          <Card heading="Altro">
            <Row as="li" className="card__row" justify="between">
              <div className="card__row-title">Id</div>
              {user.id}
            </Row>

            <Row as="li" className="card__row" justify="between">
              <div className="card__row-title">Data di creazione</div>
              {formatDateHour(user.creationTimestamp)}
            </Row>

            <Row as="li" className="card__row" justify="between">
              <div className="card__row-title">Ultima modifica</div>
              {formatDateHour(user.lastEditTimestamp)}
            </Row>
          </Card>
        </Col>
      </div>

      {editUserDataModalOpen &&
        <Modal
          close={(): void => setEditUserDataModalOpen(false)}
          title="Modifica dati utente"
        >
          <EditUserDataForm
            defaultValues={user as User}
            onSuccess={(userData: User): void => {
              setUser(userData)
              setEditUserDataModalOpen(false)
              toast.success("Dati aggiornati correttamente")
            }}
          />
        </Modal>
      }
    </>
  )
}

export default UserGeneral